import * as React from 'react';
import { Tooltip } from 'antd';
import { AgentType } from './types';
import { AskAiLogoIcon, SupportAgentIcon, BiAgentIcon } from '../../../assets/images/askAiIcons';

interface ChatHeaderProps {
  selectedAgent: AgentType;
  showBI: boolean;
  classes: any;
  t: any;
  onAgentChange: (agent: AgentType) => void;
  onClearChat: () => void;
}

const ChatHeader: React.FC<ChatHeaderProps> = ({ 
  selectedAgent, 
  showBI, 
  classes, 
  t, 
  onAgentChange, 
  onClearChat 
}) => {
  return (
    <div className={classes.chatHeaderContainer}>
      <div className={classes.chatHeader}>
        <div className={classes.chatHeaderTop}>
          <div className={classes.chatBrand}>
            <div className={classes.chatLogo}>
                <AskAiLogoIcon width={18} height={18} />
            </div>
            <div className={classes.chatTitle}>Ask AI</div>
          </div>
        </div>

        <div className={classes.personaSelector}>
          <button 
            className={`${classes.personaBtn} ${selectedAgent === AgentType.SUPPORT ? 'active' : ''}`}
            onClick={() => onAgentChange(AgentType.SUPPORT)}
            type="button" 
            aria-label="Switch to Support Agent"
          >
            <SupportAgentIcon width={8} height={8} />
            {t('Support')}
          </button>
          {showBI && (
            <button 
              className={`${classes.personaBtn} ${selectedAgent === AgentType.BI ? 'active' : ''}`}
              onClick={() => onAgentChange(AgentType.BI)}
              type="button" 
              aria-label="Switch to BI Agent"
            >
                <BiAgentIcon width={8} height={8} />
              {t('BI')}
            </button>
          )}
        </div>
      </div>
      <Tooltip title={t('Start new chat')}>
        <button 
          className={classes.themeToggle}
          onClick={onClearChat}
          type="button"
          aria-label="Start new chat"
        >
          +
        </button>
      </Tooltip>
    </div>
  );
};

export default ChatHeader; 